import { render, staticRenderFns } from "./BatchListNav.vue?vue&type=template&id=7ddcd57a"
import script from "./BatchListNav.vue?vue&type=script&lang=ts"
export * from "./BatchListNav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports